<template>
    <div class="list">
		<sub-title title="相似推荐"></sub-title>
		
		<div class="list">
			<div class="item" v-for="(item, index) in list" :key="item.goods_id" @click="$router.pushToTab({ path: '/job-detail-' + item.id })">
				<!-- <img class="img-wrap" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" /> -->
				
				<div class="info">
					<div class="title">{{ item.title }}</div>
					<div class="salary">
						<!-- <span>薪资:</span> -->
						<p v-if="item.salary>0">{{Math.round(item.salary/1000)}}K</p>
						<p v-else>面谈</p>
					</div>
				</div>
				
				<div class="site-name">{{item.site.site_name}}</div>
			</div>
		</div>
		
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import {
		jobList,
		newsDetail
	} from "@/api/cms/job";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "sidebar",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			num: {
                type: Number,
                required: true,
				default:4
            },
        },
        data() {
            return {
				list:[],
            }
        },
        created() {
			this.getList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            getList(){
            	jobList({
            		// cat_id:15,
            		page_size:this.num
            	}).then(res=>{
            		if (res.code == 0 && res.data) {
            			this.list = res.data.list
            			// this.$set('tabs',this.tabs)
            		}
            	}).catch(err => {
            		this.$message.error(err.message);
            	});
            },
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>

.list{
	display: flex;
	flex-wrap: wrap;
	.item {
		width: 32.66666%;
		margin: 15px 1% 0 0;
		border: 1px solid #eeeeee;
		// padding-top: 10px;
		position: relative;
		padding-bottom: 5px;
		box-sizing: border-box;
		overflow: hidden;
		background-color: #F5FAFF;
		padding: 15px;
		&:nth-child(3n) {
			margin-right: 0%;
		}
	
		&:hover {
			border: 1px solid $base-color;
		}
		.info{
			display: flex;
			.title{
				width: 280px;
			}
			.salary{
				flex:1;
				color: $base-color;
				font-size: 20px;
			}
		}
		
	}
}
</style>
